export type ThemeType = {
  body: string;
  text: string;
};

export const lightTheme: ThemeType = {
  body: '#f1f1f1',
  text: '#121620'
};

export const darkTheme: ThemeType = {
  body: '#121620',
  text: '#f1f1f1'
};
